import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { compose } from 'redux';
import qs from 'qs';

import Spinner from 'components/Spinner';
import { fetchQuickCarrierRequests } from 'actions/quickCarrierRequests';
import { getQuickCarrierRequests, getPageCount } from 'reducers';
import { quickSubPage } from 'decorators/subPage';
import CarrierRequestsTable from 'components/quick/CarrierRequestsTable';
import { SubNav } from 'components/SubNav/quick';
import Pagination from 'components/Pagination/Pagination';
import { scrollToBlock } from 'helpers/scrolls';

export class QuickCarrierRequests extends Component {
  state = {
    loading: false,
  };

  componentDidMount() {
    this.loadCarrierRequests();
  }

  componentDidUpdate(oldProps) {
    const { page } = this.props;
    if (oldProps.page !== page) {
      this.loadCarrierRequests();
      scrollToBlock('#carrier-requests-title');
    }
  }

  loadCarrierRequests = () => {
    const { subId, fetchQuickCarrierRequests, page } = this.props;
    this.setState({ loading: true });

    fetchQuickCarrierRequests(subId, page)
      .catch((e) => {
        toast.error(e.message);
      })
      .finally(() => this.setState({ loading: false }));
  };

  render() {
    const { loading } = this.state;
    const { carrierRequests, sub, subId, pageCount, page } = this.props;

    return (
      <div>
        <h1 id="carrier-requests-title">Quick Carrier Requests</h1>
        <SubNav sub={sub} showNetwork />
        <CarrierRequestsTable carrierRequests={carrierRequests} />
        <Pagination
          count={pageCount}
          current={page}
          url={(nextPage) =>
            `/quick/subscriptions/${subId}/carrier-requests?page=${nextPage}`
          }
        />
        <Spinner showLoader={loading} />
      </div>
    );
  }
}

const mapStateToProps = (state, { subId, location: { search } }) => {
  const { page = 1 } = qs.parse(search, { ignoreQueryPrefix: true });
  return {
    carrierRequests: getQuickCarrierRequests(state, subId, page),
    pageCount: getPageCount(
      state,
      'quickCarrierRequests',
      `quickCarrierRequests_${subId}_`,
      page,
    ),
    page,
  };
};

const mapDispatchToProps = {
  fetchQuickCarrierRequests,
};

export default compose(
  quickSubPage,
  connect(mapStateToProps, mapDispatchToProps),
)(QuickCarrierRequests);
